import { create } from 'apisauce';

// define the api
const api = create({
    baseURL: process.env.REACT_APP_API_END_POINT || 'http://localhost:8080',
    headers: { Accept: 'application/json' },
});

const unsubscribe = (data: any) => {
    // TO_DO data type and url is not known yet
    return api.post('/unsubscribe', data);
};

export default {
    unsubscribe,
};
